import React from 'react';
import { CodeEditor } from '../questions';

function CodeWriteQuestion({ question, value = '', onChange, disabled = false }) {
  return (
    <CodeEditor
      question={question}
      value={value}
      onChange={onChange}
      disabled={disabled}
      label="Your code solution:"
    />
  );
}

export default CodeWriteQuestion;
